const defaultState = () => {
    return {
        env: process.env.NODE_ENV,
        baseApiUrl: process.env.VUE_APP_BASE_API_URL,
        stateKey: 1,
        isLoading: false,
        step: 'start',
        model: 0,
        clouds: 0,
        animationPlaying: false,
        ipData: []
    }
}

export default defaultState;

